import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homeData';

export default function ArticlesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              足球资讯
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              精选文章
            </h2>
          </div>
          <Link
            to="/category/live"
            className="mt-3 sm:mt-0 flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
          >
            阅读更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={article.link}
              className="group p-6 md:p-7 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  {article.category}
                </span>
                <span className="text-foreground-400 text-xs">{article.date}</span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4 flex-1">
                {article.summary}
              </p>
              <div className="flex items-center gap-1 text-foreground-400 text-xs">
                <i className="ri-time-line"></i>
                <span>阅读约 {article.readTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}